export const GLOBAL_TOAST_KEY = 'global-toast';
export const GLOBAL_MESSAGE_KEY = 'global-message';